import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Busca, Orcamento, Paginacao, Usuario } from 'src/app/model';
import { Circuito, FiltroAdicional, FiltroCircuito } from 'src/app/model/turismo/circuito.model';
import { CircuitoService } from 'src/app/services/turismo/circuito.service';

@Component({
  selector: 'app-circuito',
  standalone: false,
  templateUrl: './circuito.component.html',
  styleUrl: './circuito.component.scss'
})
export class CircuitoComponent implements OnInit {
  @Output() selecionouCircuito = new EventEmitter<any>();
  @Output() removeuCircuito = new EventEmitter<any>();
  @Output() abrirModalPreOrcamento = new EventEmitter<Circuito>();

  @Input() circuito: Circuito;
  @Input() usuario: Usuario;
  @Input() agenciaId: number;
  @Input() selecionar = true;
  @Input() orcamento: Orcamento;

  Paginacao: Paginacao = new Paginacao();
  FiltroCircuito: FiltroCircuito = new FiltroCircuito();
  FiltrosAdicionais: FiltroAdicional = new FiltroAdicional();

  Circuitos = [];
  originalItemsCidades = [];
  originalItemsPais = [];
  PaisesFiltro: string[] = [];
  CidadesFiltro: string[] = [];
  itemReserva: any;
  filtrou: any = false;

  Fornecedores: string[] = [];
  Temporadas: string[] = [];
  Temporada: string;

  OrcamentoReserva: Orcamento = new Orcamento();

  adicionando: boolean = false;
  buscando = false;
  MensagensErro: any;
  MensagensSucesso: any;

  constructor(
    private modalService: NgbModal,
    private circuitoService: CircuitoService,
  ) {}

  ngOnInit() {
  }

  buscarPagina(pagina) {
    document.querySelector('.scrollable-container').scrollTop = 0;
    this.Paginacao.NumeroPagina = pagina;
  }

  selecionouCategoria(circuito: any) {
    circuito.CategorinaNome = circuito.CategoriasCircuitos.find(x => x.Codigo == circuito.CategoriaCodigo).Nome;
  }

  abrirModal() {
    this.abrirModalPreOrcamento.emit(this.circuito);
  }

  removeu(circuito: any) {
    this.removeuCircuito.emit(circuito);
  }

  selecionou(circuito: any) {
    this.selecionouCircuito.emit(circuito);
  }
}
